import Vue from 'vue2'
import Vuex from 'vuex'
import authStore from './auth-store.js'
import bannerStore from './banner-store.js'
import cartStore from './cart-store.js'
import commonStore from './common-store.js'
import missionStore from './mission-store.js'
import orderStore from './order-store.js'
import productStore from './product-store.js'
import registrationStore from './registration-store.js'
import rewardsStore from './rewards-store.js'
import npsStore from './nps-store.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    authStore,
    bannerStore,
    cartStore,
    commonStore,
    missionStore,
    orderStore,
    productStore,
    registrationStore,
    rewardsStore,
    npsStore
  }
})

